/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const PointerChevronDown24 = (props: SVGProps) => (
    <AccessibleSVG width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M11.162 19.864c-.555-.182-1.086-.535-1.593-1.057L.559 9.264A2.004 2.004 0 010 7.9c-.008-.514.155-.945.488-1.293A1.87 1.87 0 011.855 6a1.75 1.75 0 011.343.558l8.796 9.33 8.796-9.33c.364-.38.808-.566 1.331-.558.523.008.975.21 1.355.606.365.332.539.76.523 1.281a2.02 2.02 0 01-.594 1.377l-8.986 9.567c-.508.506-1.039.85-1.593 1.033a2.604 2.604 0 01-1.664 0z"
        />
    </AccessibleSVG>
);

export default PointerChevronDown24;
